/**
 * This util gets the target for urls
 * It returns `_blank` for external urls ( non miro.com ) and `_self` for internal ( miro.com and relative )
 */
export default function getLinkTarget(url) {
  if (url !== null && url !== void 0 && url.startsWith('http') && !(url !== null && url !== void 0 && url.startsWith('https://miro.com'))) {
    return '_blank';
  }

  return '_self';
}